<template>
	<!-- <div v-if="isOpen" class="fixed flex justify-center items-center inset-0"> -->
	<div v-if="isOpen" class="modal-container-c">
		<!-- backgroun overlay -->
		<!-- <div class="absolute inset-0 bg-black opacity-25" @click="handleOverlayClick"></div> -->
		<div class="modal-background" @click="handleOverlayClick"></div>

		<!-- <div class="card z-10 p-0"> -->
		<div :class="`card ${isBackgroundTransparent ? 'bg-transparent' : ''}`">
			<!-- <div v-if="isHeader" class="flex justify-between items-center border-b-2 p-6"> -->
			<div v-if="isHeader" class="modal-header-c">
				<div class="text-lg font-medium">{{ title }}</div>
				<!-- <div class="cursor-pointer" @click="closeModal">
					&#10005;
				</div> -->
				<IconButtonClose />
			</div>

			<div :class="`flex justify-center modal-body-c ${classBody} ${isBackgroundTransparent ? 'bg-transparent' : ''}`">
				<slot></slot>
			</div>

			<div v-if="isFooter" class="border-t-2 p-6">
				<slot name="footer"></slot>
			</div>
		</div>
	</div>
</template>

<script>
import IconButtonClose from './icons/IconButtonClose.vue'

export default {
	name: 'ModalComponent',

	props: {
		title: {
			type: String,
			default: 'Modal Title',
		},
		isHeader: {
			type: Boolean,
			default: true,
		},
		isFooter: {
			type: Boolean,
			default: true,
		},
		defaultOpen: {
			type: Boolean,
			default: false,
		},
		closeOnBackgroundClick: {
			type: Boolean,
			default: true,
		},
		isBackgroundTransparent: {
			type: Boolean,
			default: false,
		},
		classBody: {
			type: String,
			default: '',
		},
	},

	components: {
		IconButtonClose,
	},

	data() {
		return {
			isOpen: this.defaultOpen,
		}
	},

	methods: {
		openModal() {
			this.isOpen = true
		},
		closeModal() {
			this.$emit('close')
			this.isOpen = false
		},
		handleOverlayClick() {
			if (this.closeOnBackgroundClick) {
				this.closeModal()
			}
		},
	},
}
</script>

<style scoped>
.modal-container-c {
	display: flex;
	position: fixed;
	justify-content: center;
	align-items: start;
	padding-top: 6rem;
	inset: 0;
	overflow-y: auto;
	overscroll-behavior-y: contain;
	z-index: 20;
}

.modal-background {
	background-color: rgba(0, 0, 0, 0.5);
	position: fixed;
	inset: 0;
	/* opacity: 0.25; */
}

.modal-header-c {
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-bottom: 2px solid var(--grey-2-color);
	padding: 1.5em 2em;
}

.modal-body-c {
	background-color: var(--grey-2-color);
	border-radius: 0.25rem;
	/* min-width: 32.75em; */
}
</style>